import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	breatheIn: {
		id: 'breathe.breathPulser.breatheIn',
		defaultMessage: 'breathe in',
		description: 'breath in description',
	},
	breatheOut: {
		id: 'breathe.breathPulser.breatheOut',
		defaultMessage: 'breathe out',
		description: 'breath out description',
	},
	twoMoreBreaths: {
		id: 'breathe.breathPulser.twoMoreBreaths',
		defaultMessage: '2 breaths left',
		description: 'Copy when two more breaths in bubble',
	},
	lastBreath: {
		id: 'breathe.breathPulser.lastBreath',
		defaultMessage: 'Last deep breath',
		description: 'Copy when one more breath in bubble',
	},
	finish: {
		id: 'breathe.finish',
		defaultMessage: 'Finish',
		description: 'Finish description',
	},
});
